// Module
var code = `<ul class="importer-upload-criteria" style="width:400px"> <li> Make sure all the following required columns are filled in:<br/> <strong>Account Code, Account Description, Type, Subcode, Subcode Description, Subcode Type</strong> </li> <li> <strong>Account Code</strong> and <strong>Subcode</strong> can have at most 50 characters </li> </ul> `;
// Exports
module.exports = code;